<template>
  <page-view title="使用后情况">
    <template slot="action">
      <a-button type="primary" :loading="saveLoading" @click="onSubmit">保存</a-button>
    </template>
    <a-card>
      <a-form-model :model="form" ref="form" :rules="rules" class="custom pick-100 form-input">
        <a-row>
          <a-col :span="11">
            <a-form-model-item label="实际天数" prop="practicalDays">
              <a-input-number disabled :min="0" :step="0.5" v-model="form.practicalDays" style="width: 80%"/>
              （天）
            </a-form-model-item>
          </a-col>
          <a-col :span="11" :offset="1">
            <a-form-model-item label="实际总计金额" prop="practicalTotalPrices">
              <a-input-number disabled :min="0" v-model="form.practicalTotalPrices" style="width: 80%"/>
              （元）
            </a-form-model-item>
          </a-col>
        </a-row>
        <div class="hp-title">
          <div></div>
          <span>反馈情况</span> &nbsp;
          <a-button type="primary" @click="onCopy">以第一个专家出行记录为模板复制</a-button>
          <p class="mb-0 size1"></p>
        </div>
        <a-card v-for="(expert, index) in form.feedbackList">
          <a-row :getter="40">
            <a-col :span="3">
              <a-form-model-item prop="expertId">
                <b style="font-size: x-large;">{{ expert.extras.expert_name }}</b>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="专家评价" :prop="'feedbackList.' + index + '.expertStatus'" :rules="{ required: true,message: '专家评价不能为空！',trigger: 'change', }">
                <dict-radio dictKey="selExpert_expertStatus" v-model="expert.expertStatus" @change="v => onStatusChange(v,expert) "/>
              </a-form-model-item>
            </a-col>
            <a-col :span="8" v-if="expert.professionalTitle !== '1'">
              <a-form-model-item label="专家税后薪酬" :prop="'feedbackList.' + index + '.fees'" :rules="{ required: true, message: '专家税后薪酬不能为空！', trigger: 'change', }">
                ￥ {{ expertFees(expert) }} (元)
              </a-form-model-item>
            </a-col>
            <a-col :span="5" v-if="expert.professionalTitle === '1'">
              <a-form-model-item label="专家税后薪酬" :prop="'feedbackList.' + index + '.fees'" :rules="{ required: true, message: '专家税后薪酬不能为空！' }">
                <a-input placeholder="请输入" style="width: 200px" v-model="expert.fees" :value="expertFees(expert)">
                  <div slot="addonAfter" style="color: blue" title="具有正高级技术职称或同等专业水平以上的人员开展技术服务工作的，专家费参照《广州市本级专家劳务费定额标准》执行。"><a-icon type="question-circle"/></div>
                </a-input >
              </a-form-model-item>
            </a-col>
            <a-col :span="5" v-if="expert.professionalTitle === '1'">
              <a-form-model-item label="正高级职称薪酬/天">
                <a-input placeholder="请输入" style="width: 200px" v-model="expert.dayAmo" @change="onChangeZGAms(expert)"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" :offset="3">
              <a-form-model-item label="弄虚作假" :prop="'feedbackList.' + index + '.forgery'" :rules="{ required: false, message: '弄虚作假！', trigger: 'change', }">
                <a-radio-group name="radioGroup" v-model="expert.forgery">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="徇私舞弊" :prop="'feedbackList.' + index + '.fraud'" :rules="{  required: false, message: '徇私舞弊！', trigger: 'change',  }">
                <a-radio-group name="radioGroup" v-model="expert.fraud">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="收受他人财物" :prop="'feedbackList.' + index + '.collectProperty'" :rules="{  required: false, message: '徇私舞弊！', trigger: 'change',  }">
                <a-radio-group name="radioGroup" v-model="expert.collectProperty">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="5" :offset="3">
              <a-form-model-item label="擅自与行政相对人进行商业性接洽" :prop="'feedbackList.' + index + '.businessContact'" :rules="{ required: false, message: '擅自与行政相对人进行商业性接洽！', trigger: 'change',  }">
                <a-radio-group name="radioGroup" v-model="expert.businessContact">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="发表不当言论造成恶劣影响的" :prop="'feedbackList.' + index + '.publishAffect'" :rules="{  required: false, message: '发表不当言论造成恶劣影响的！', trigger: 'change', }">
                <a-radio-group name="radioGroup" v-model="expert.publishAffect">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
            <a-col :span="5">
              <a-form-model-item label="被证实有犯罪行为或严重违法行为的" :prop="'feedbackList.' + index + '.crime'" :rules="{   required: false, message: '被证实有犯罪行为或严重违法行为的！',   trigger: 'change', }">
                <a-radio-group name="radioGroup" v-model="expert.crime">
                  <a-radio :value="1">
                    是
                  </a-radio>
                  <a-radio :value="0">
                    否
                  </a-radio>
                </a-radio-group>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-form-model-item label="专家出行记录">
                <a-table style="margin-top: 10px" :dataSource="expert.tripDateList" :columns="tripDateColumns" :pagination="false">
                  <template slot="tripDateTitle"><span v-if="expert.comp" style="color: red">*</span> 专家出行日期</template>
                  <template slot="totalTypeTitle"><span v-if="expert.comp" style="color: red">*</span> 出行计划类型</template>
                  <template slot="dayTypeTitle"><span v-if="expert.comp" style="color: red">*</span> 出行天数类型</template>
                  <template slot="workOver">超时工作</template>
                  <template slot="tripDate" slot-scope="text, record, index2">
                    <a-form-model-item :prop="'feedbackList.' + index +'.tripDateList.' + index2 + '.tripDate'" :rules="{  required: true, message: '专家出行日期不能为空！', trigger: 'change', }">
                      <a-date-picker style="width: 100%" :format="'yyyy-MM-DD'" v-model="record.tripDate" @change="countDay"/>
                    </a-form-model-item>
                  </template>
                  <template slot="totalType" slot-scope="text, record, index2">
                    <a-form-model-item :prop="'feedbackList.' + index +'.tripDateList.' + index2 + '.totalType'" :rules="{ required: true, message: '出行计划类型不能为空！', trigger: 'change', }">
                      <a-radio-group v-model="record.totalType" @change="countDay">
                        <a-radio value="W">室外</a-radio>
                        <a-radio value="N">室内</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </template>
                  <template slot="dayType" slot-scope="text, record, index2">
                    <a-form-model-item :prop="'feedbackList.' + index +'.tripDateList.' + index2 + '.dayType'" :rules="{ required: true, message: '出行天数类型不能为空！', trigger: 'change', }">
                      <a-radio-group @change="countDay" v-model="record.dayType">
                        <a-radio value="1">一天</a-radio>
                        <a-radio value="0">半天</a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </template>

                  <template slot="workOver" slot-scope="text, record, index2">
                    <a-form-model-item :prop="'feedbackList.' + index +'.tripDateList.' + index2 + '.workOver'" :rules="{ required: false, message: '出行天数类型不能为空！', trigger: 'change', }">
                      <a-select style="width: 170px" v-model="record.workOver" placeholder="可选择" @change="changeWorkOver" allowClear>
                        <a-select-option value="1">4小时</a-select-option>
                        <a-select-option value="2">8小时</a-select-option>
                        <a-select-option value="3">12小时</a-select-option>
                        <a-select-option value="4">16小时</a-select-option>
                      </a-select>
                    </a-form-model-item>
                  </template>

                  <template slot="action" slot-scope="text, record">
                    <a-popconfirm v-if="tripDateList.length" title="确定要删除吗?" @confirm="() => onDataDelete(record.key,expert)">
                      <a-button type="danger">删除</a-button>
                      <!--<a href="javascript:;" style="color: red;">删除</a>-->
                    </a-popconfirm>
                  </template>
                </a-table>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-button style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus" @click="onDataAdd(expert)">
                添加一条记录
              </a-button>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="23">
              <a-form-model-item class="not-null" label="情况说明 (必须写专家出行日期)" prop="remark">
                <a-textarea v-model="expert.remark" rows="1"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form-model>
    </a-card>
  </page-view>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import { PageView } from '@/layouts'
import DictRadio from '@/components/dict/DictRadio.vue'

import { expertStatusList } from '@/epp/expertmain/selectexpertapply/common/SefUtils.js'

const rules = {
  practicalDays: [{ required: true, message: '实际天数不能为空', trigger: 'blur' }],
  practicalTotalPrices: [{ required: true, message: '实际总计金额不能为空', trigger: 'blur' }],
  tripDate: [{ required: true, message: '专家出行日期不能为空', trigger: 'change' }],
  totalType: [{ required: true, message: '出行计划类型不能为空', trigger: 'change' }],
  dayType: [{ required: true, message: '出行天数类型不能为空', trigger: 'change' }],
  workOver: [{ required: false, message: '超时工作时长不能为空', trigger: 'change' }],
  remark: [{ required: false, message: '情况说明不能为空', trigger: 'change' }]
}

const defaultForm = { practicalDays: 0, practicalTotalPrices: 0, feedbackList: [{ extras: {} }] }

export default {
  name: 'FeedbackForm',
  components: {
    PageView,
    DictRadio
  },
  data () {
    return {
      rules,
      options: expertStatusList,
      id: this.$route.query.id,
      user: this.$ls.get('user'),
      saveLoading: false,
      comp: true,
      tripDateColumns: [
        { slots: { title: 'tripDateTitle' }, align: 'center', dataIndex: 'tripDate', scopedSlots: { customRender: 'tripDate' } },
        { slots: { title: 'totalTypeTitle' }, align: 'center', dataIndex: 'totalType', scopedSlots: { customRender: 'totalType' } },
        { slots: { title: 'dayTypeTitle' }, align: 'center', dataIndex: 'dayType', scopedSlots: { customRender: 'dayType' } },
        { slots: { title: 'workOver' }, align: 'center', dataIndex: 'workOver', scopedSlots: { customRender: 'workOver' } },
        { title: '操作', align: 'center', dataIndex: 'action', scopedSlots: { customRender: 'action' } }
      ],
      form: { ...defaultForm }
    }
  },
  computed: {
    expertFees () {
      return function (expert) {
        if (!expert.tripDateList) {
          return 0
        }
        if (expert.expertStatus === '4') {
          expert.fees = 0
          this.practicalTotalPrices()
          return 0
        }
        if (expert.expertStatus === '9') {
          expert.fees = 0
          this.practicalTotalPrices()
          return 0
        }

        var dayAmo = 0
        var sumFees = 0
        expert.tripDateList.forEach(item => {
          if (item.tripDate && item.totalType && item.dayType) {
            if (item.totalType === 'W') {
              dayAmo = 1000
            } else if (item.totalType === 'N') {
              dayAmo = 800
            }
            if (expert.professionalTitle === '1') {
              if (expert.isEditAmo) {
                if (expert.dayAmo !== '' && expert.dayAmo !== undefined && expert.dayAmo !== 0 && expert.dayAmo !== null) {
                  dayAmo = expert.dayAmo
                }
              }
            }
            sumFees += dayAmo * (item.dayType === '1' ? 1 : 0.5)
            if (item.workOver) {
              sumFees = sumFees + ((dayAmo * 0.5) * item.workOver)
            }
          }
        })
        expert.fees = sumFees
        if (sumFees !== 0) {
          this.practicalTotalPrices()
        }
        if (expert.professionalTitle === '1' && expert.tripDateList.length > 0 && dayAmo > 0) {
          expert.dayAmo = dayAmo
        }
        return sumFees
      }
    },
    expertFeesSub () {
      return function (expert) {
        if (!expert.tripDateList) {
          return 0
        }
        if (expert.expertStatus === '4') {
          expert.fees = 0
          this.practicalTotalPrices()
          return 0
        }
        var sumFees = 0
        expert.tripDateList.forEach(item => {
          if (expert.professionalTitle === '1') {
            sumFees += expert.fees * (item.dayType === '1' ? 1 : 0.5)
          }
        })
        expert.fees = sumFees
        if (sumFees !== 0) {
          this.practicalTotalPrices()
        }
        return sumFees
      }
    }
  },
  created () {
    const that = this
    this.initTripDate()
    this.$http.get(`/api/1/expertmain/selectExpertApply/get_selectExpertApply.json?id=${this.id}`).then(res => {
      if (res.code !== 200) {
        return
      }
      that.form.practicalDays = res.result.practicalDays ? res.result.practicalDays : 0
      that.form.practicalTotalPrices = res.result.practicalTotalPrices ? res.result.practicalTotalPrices : 0
      let tripDate = res.result.applyDate
      that.form.feedbackList = res.result.extras.feedbackList.map(item => {
        let data = {
          id: item.id,
          remark: item.remark,
          expertStatus: item.expertStatus,
          extras: item.extras,
          forgery: item.forgery ? item.forgery : 0,
          fraud: item.fraud ? item.fraud : 0,
          collectProperty: item.collectProperty ? item.collectProperty : 0,
          businessContact: item.businessContact ? item.businessContact : 0,
          publishAffect: item.publishAffect ? item.publishAffect : 0,
          crime: item.crime ? item.crime : 0,
          workOver: item.workOver,
          dayAmo: item.dayAmo,
          isEditAmo: item.dayAmo != null,
          tripDateList: [],
          professionalTitle: item.professionalTitle,
          comp: !(item.expertStatus === '4' || item.expertStatus === '9')
        }
        var workStr = item.workOver
        if (!workStr) {
          workStr = undefined
        }
        if (item.tripDate) {
          // 12.01W,12.02N半天
          let tripDateStrList = item.tripDate.split(',')
          let i = 1
          tripDateStrList.map((item) => {
            let tripDate = moment(moment().year() + '.' + item.substring(0, 5), 'YYYY.MM.DD')
            let dayType = item.indexOf('半天') > 0 ? '0' : '1'
            let totalType = item.substring(5, 6)
            data.tripDateList.push({ key: i, tripDate: tripDate, dayType: dayType, totalType: totalType, workOver: workStr })
            i++
          })
        } else {
          let today = new Date(Date.parse(res.result.applyDate))
          let dd = new Date()
          let dayTypeBr = false
          let planDays = res.result.planDays
          let planDaysSP = (planDays + '').split('.')
          if (planDaysSP.length > 1) {
            planDays = planDays + 0.5
            dayTypeBr = true
          }
          for (let i = 1; i <= planDays; i++) {
            let tripDate = moment(dd.setDate(today.getDate() + i - 1)).format('YYYY.MM.DD')
            let dayType = '1'
            if (dayTypeBr && planDays === i) {
              dayType = '0'
            }
            let totalType = 'W'
            if (res.result.planExpertFees === '800') {
              totalType = 'N'
            }
            data.tripDateList.push({ key: i, tripDate: tripDate, dayType: dayType, totalType: totalType, workOver: workStr })
          }
        }
        return data
      })
    })
  },
  methods: {
    onChangeZGAms (val) {
      let that = this
      that.form.feedbackList.forEach(e => {
        if (val.id === e.id) {
          e.isEditAmo = true
        }
      })
    },
    editFees (val) {
      let that = this
      that.form.feedbackList.forEach(e => {
        if (val.id === e.id) {
          e.fees = val.fees
          e.editStr = '1'
        }
      })
      that.expertFees(that.form.feedbackList)
    },
    onStatusChange (e, item) {
      item.expertStatus = e
      this.countDay()
      // 废弃 -- 缺席
      if (e === '4' || e === '9') {
        item.comp = false
      } else {
        item.comp = true
      }
    },
    countDay () {
      var filter1 = this.form.feedbackList.filter(e => e.expertStatus != null && e.expertStatus !== '4' && e.expertStatus !== '9')
      if (filter1.length === 0) {
        this.form.practicalDays = 0
        return
      }
      let list = filter1[0].tripDateList
      var day = 0
      const rr = new Map()
      var filter = list.filter((a) => !rr.has(moment(a.tripDate).format('YYYY-MM-DD')) && rr.set(moment(a.tripDate).format('YYYY-MM-DD'), 1))
      filter.forEach(e => {
        var ts = list.filter(a => moment(e.tripDate).format('YYYY-MM-DD') === moment(a.tripDate).format('YYYY-MM-DD'))
        var ts1 = ts.sort((a, b) => a['dayType'] < b['dayType'] ? 1 : -1)
        if (ts1.length === 1) {
          if (ts1[0].dayType === '1') {
            day += 1
          } else if (ts1[0].dayType === '0') {
            day += 0.5
          }
        } else {
          var size = ts1.length > 2 ? 2 : ts1.length
          for (let i = 0; i < size; i++) {
            const element = ts1[i]
            if (element.dayType === '1') {
              day += 1
              break
            } else if (element.dayType === '0') {
              day += 0.5
            }
          }
        }
      })
      if (day !== 0) {
        this.form.practicalDays = day
      }
    },
    initTripDate () {
      this.tripDateList = []
      this.tripDateList = [...this.tripDateList, { key: 1, tripDate: '' }]
    },
    onData (key, value, expert) {
      let tripDateList = [...expert.tripDateList]
      let target = tripDateList.find(item => item.key === key)
      if (target) {
        target['tripDate'] = value
        expert.tripDateList = tripDateList
      }
    },
    onDataDelete (key, expert) {
      let tripDateList = [...expert.tripDateList]
      expert.tripDateList = tripDateList.filter(
        item => item.key !== key
      )
      this.onDataFormat(expert)
    },
    onDataAdd (expert) {
      let newData = { key: '', tripDate: expert.extras.apply_date, dayType: '', totalType: '', workOver: undefined }
      expert.tripDateList = [...expert.tripDateList, newData]

      this.onDataFormat(expert)
    },
    onCopy () {
      var list = this.form.feedbackList[0]

      this.form.feedbackList.forEach(item => {
        item.tripDateList = list.tripDateList
        item.expertStatus = list.expertStatus
        item.remark = list.remark
      })
    },
    practicalTotalPrices () {
      var sumCountFees = 0
      this.form.feedbackList.forEach(item => {
        if (item.fees) {
          sumCountFees += item.fees
        }
      })
      this.form.practicalTotalPrices = sumCountFees
    },
    onDataFormat (expert) {
      let seqno = 0
      let tripDateList = expert.tripDateList.map(item => {
        seqno += 1
        item.key = seqno
        return item
      })
      expert.tripDateList = tripDateList
    },
    changeWorkOver () {

    },
    onSubmit () {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        const data = { ...this.form }
        let list = data.feedbackList[0].tripDateList
        const rr = new Map()

        if (list.length > 0) {
          var filter = list.filter((a) => !rr.has(moment(a.tripDate).format('YYYY-MM-DD')) && rr.set(moment(a.tripDate).format('YYYY-MM-DD'), 1))
          for (let j = 0; j < filter.length; j++) {
            var e = filter[j]
            var ts = list.filter(a => moment(e.tripDate).format('YYYY-MM-DD') === moment(a.tripDate).format('YYYY-MM-DD'))
            var ts1 = ts.sort((a, b) => a['dayType'] < b['dayType'] ? 1 : -1)
            if (ts1.length > 2) {
              this.$message.error('出行时间，' + moment(ts1[0].tripDate).format('YYYY-MM-DD') + '出行天数大于1天请从新选择！')
              return
            }
            if (ts1.length > 1) {
              if (ts1[0].dayType === '1') {
                this.$message.error('出行时间，' + moment(ts1[0].tripDate).format('YYYY-MM-DD') + '出行天数大于1天请从新选择！')
                return
              }
            }
          }
        }

        var inRow = 1
        for (const key in data.feedbackList) {
          var item = data.feedbackList[key]
          if (item.tripDateList.length > 0) {
            item.workOver = item.tripDateList[0].workOver
          }
          if (!item.isEditAmo) {
            item.dayAmo = null
          }
          let tripDate = ''
          if (item.expertStatus === '4') {
            item.feesState = '1'
          } else {
            if (item.tripDateList.length === 0) {
              this.$message.error('出行记录不能为空！请填写出行记录')
              return
            }
          }
          if ((!item.remark) || item.remark.length === 0) {
            this.$message.error('第' + inRow + '个专家的情况说明不能为空！请填写出行记录')
            return
          }
          delete item.extras
          item.tripDateList.map((item2) => {
            let date = moment(new Date(item2.tripDate)).format('MM.DD')
            let dayType = item2.dayType !== '1' ? '半天' : ''
            tripDate += date + item2.totalType + dayType + ','
          })
          tripDate = tripDate.slice(0, tripDate.length - 1)
          item.tripDate = tripDate
          delete item.tripDateList
          inRow++
        }
        this.saveLoading = true
        const res = await this.$http.post('/api/1/expertmain/selectExpertFeedback/update_selectExpertFeedback.json', data)
        this.saveLoading = false
        if (res.code !== 200) {

        }
        this.$message.success('保存成功')
        this.$router.push({
          path: '/selectExpertApply/view?id=' + this.id
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.process-list /deep/ .title {
  width: 110px;
}

.process-list {
  padding-bottom: 16px;
}

.textarea {
  height: 80px;
}

.hp-title {
  padding-top: 15px;
  padding-bottom: 15px;
}

.hp-title div {
  height: 18px;
  border-left: 5px solid dodgerblue;
  width: 15px;
  display: inline-block;
}

.hp-title span {
  font-size: 16px;
  font-weight: bold
}

.not-null::before {
  /*top: 6px;*/
  /*left: 8px;*/
  color: red;
  content: '*';
  position: absolute;
  margin-left: -7px;
  font-weight: 700;
  line-height: 1.8em;
}

.ant-form-item {
  margin: 0;
}
</style>
